import React from 'react';
type IconVariant = 'full' | 'dpad' | 'buttons' | 'joystick' | 'triggers';
interface ControllerIconProps extends React.SVGProps<SVGSVGElement> {
  variant: IconVariant;
}
export function ControllerIcon({
  variant,
  className = '',
  ...props
}: ControllerIconProps) {
  const baseClasses = 'fill-none stroke-current stroke-[1.5] stroke-linecap-round stroke-linejoin-round';
  switch (variant) {
    case 'full':
      return <svg viewBox="0 0 24 24" className={`${baseClasses} ${className}`} {...props} data-id="element-10">
          <rect x="2" y="6" width="20" height="12" rx="6" data-id="element-11" />
          <path d="M6 12h4m-2-2v4" data-id="element-12" />
          <circle cx="15" cy="13" r="1" fill="currentColor" data-id="element-13" />
          <circle cx="17" cy="11" r="1" fill="currentColor" data-id="element-14" />
        </svg>;
    case 'dpad':
      return <svg viewBox="0 0 24 24" className={`${baseClasses} ${className}`} {...props} data-id="element-15">
          <path d="M9 3h6v6h6v6h-6v6H9v-6H3V9h6V3z" data-id="element-16" />
        </svg>;
    case 'buttons':
      return <svg viewBox="0 0 24 24" className={`${baseClasses} ${className}`} {...props} data-id="element-17">
          <circle cx="12" cy="6" r="2" data-id="element-18" />
          <circle cx="18" cy="12" r="2" data-id="element-19" />
          <circle cx="12" cy="18" r="2" data-id="element-20" />
          <circle cx="6" cy="12" r="2" data-id="element-21" />
        </svg>;
    case 'joystick':
      return <svg viewBox="0 0 24 24" className={`${baseClasses} ${className}`} {...props} data-id="element-22">
          <circle cx="12" cy="12" r="8" data-id="element-23" />
          <circle cx="10" cy="10" r="4" data-id="element-24" />
        </svg>;
    case 'triggers':
      return <svg viewBox="0 0 24 24" className={`${baseClasses} ${className}`} {...props} data-id="element-25">
          <path d="M4 8V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v2" data-id="element-26" />
          <path d="M4 12v-2a4 4 0 0 1 4-4h8a4 4 0 0 1 4 4v2" data-id="element-27" />
        </svg>;
    default:
      return null;
  }
}